import Container from '@packages/justo-parts/lib/components/Container'
import {Suspense, useState} from 'react'
import Categories from './Categories'
import SearchedResults from './SearchedResults'

export default function ProductsList({
  productsContentProps,
  filter,
  searchResults,
  sorting,
  categoriesRefs,
}) {
  const {layout, router, nextOpenDate} = productsContentProps
  const isSearching = router.query.search || filter
  const [_select, setSelect] = useState(null)
  const [_open, setOpen] = useState(false)
  const isLayoutV2 = layout === 'v2'

  const Menu = () => {
    return (
      <>
        {isSearching ? (
          <SearchedResults
            productsContentProps={productsContentProps}
            searchResults={searchResults}
            sorting={sorting}
            setOpen={setOpen}
            setSelect={setSelect}
          />
        ) : (
          <Categories
            productsContentProps={productsContentProps}
            sorting={sorting}
            setOpen={setOpen}
            setSelect={setSelect}
            categoriesRefs={categoriesRefs}
          />
        )}
      </>
    )
  }

  return (
    <Suspense fallback={null}>
      {isLayoutV2 ? (
        <Container>
          {nextOpenDate}
          <br />
          <Menu />
        </Container>
      ) : (
        <Menu />
      )}
    </Suspense>
  )
}
